// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-details-notification .bx--toast-notification--error .bx--toast-notification__close-button{display:none}.bx--toast-notification{width:280px}.bx--toast-notification__title{font-size:14px}.bx--toast-notification__subtitle{font-size:12px}.bx--toast-notification__caption{font-size:10px}", ""]);
// Exports
module.exports = exports;
